import { CreatePatientResponseDto } from "../dto/create-patient-reponse-dto";
import { CreatePatientResponseEntity } from "@/domain/entity/create-patient-response-entity";
import { assertCreatePatientResponseDto } from "@/utils/validation";

export class PatientCreateResponseMapper {
  static toEntity(patientResponseDto: CreatePatientResponseDto): CreatePatientResponseEntity {
    // AST 기반 타입 검증
    assertCreatePatientResponseDto(patientResponseDto);

    return {
      patientUuid: patientResponseDto.patientUuid,
    };
  }
}
